// Its own module (not AuthContext.tsx) so pages that test against a mocked
// AuthContext still get the real class for their instanceof checks.

/**
 * PR #3275 (Codex bot, on 973f08f7) — a login() or register() whose response
 * arrived after a NEWER user-initiated session change started (another
 * login/register, setSession, setAuthFromToken, logout) installs nothing and
 * rejects with this. Callers treat it as silent: no error message — the user
 * has moved on, and the newer session is the one in place.
 */
export class LoginSupersededError extends Error {
  constructor() {
    super('This sign-in was superseded by a newer one.');
    this.name = 'LoginSupersededError';
  }
}
